module.exports = __webpack_public_path__ + "img/topbriefcasefilled.4e90960a.svg";